import { createSlice } from '@reduxjs/toolkit';

import { COURSE_PAUSE_REQUEST_FILTERS } from '@courseResume/data/coursePauseRequestFilters';

const initialState = {
  isModalOpen: false,
  learnerEmail: { applied: '', current: '' },
  currentBatch: { applied: null, current: null },
  newBatch: { applied: null, current: null },
  fromToBeResumedDate: { applied: null, current: null },
  untilToBeResumedDate: { applied: null, current: null },
  pauseDuration: { applied: null, current: null },
  courseType: { applied: null, current: null },
};

export const coursePauseRequestFilter = createSlice({
  name: 'coursePauseRequestFilter',
  initialState,
  reducers: {
    setCoursePauseFilterModalState: (state, action) => {
      state.isModalOpen = action.payload;
    },
    setFilterValue: (state, action) => {
      const { type, key, value } = action.payload;
      state[key][type] = value;
    },
    applyCurrentFilter: (state, action) => {
      for (const key in COURSE_PAUSE_REQUEST_FILTERS) {
        state[key].applied = state[key].current;
      }
      state.isModalOpen = false;
    },
    removeFilter: (state, action) => {
      state[action.payload] = initialState[action.payload];
    },
    resetFilters: (state) => {
      for (const key in COURSE_PAUSE_REQUEST_FILTERS) {
        state[key] = initialState[key];
      }
    },
  },
});

export const {
  applyCurrentFilter,
  removeFilter,
  setCoursePauseFilterModalState,
  setFilterValue,
  resetFilters,
} = coursePauseRequestFilter.actions;
export default coursePauseRequestFilter.reducer;
